import AuthClass from '../mw-home-auth-class';

export default class MwHomeLoginPageComponent extends AuthClass {}